
import AppLayout from "../layout/AppLayout";

const NotFound = () => {
  return (
    <AppLayout>
      <h1>Not found Page</h1>
    </AppLayout>
  );
};

export default NotFound;
